import React, { useEffect } from 'react'
import { NextPageWithLayout } from '@chegg-wt/core/types/layout'
import ProofReaderLayout from '@chegg-wt/core/components/ProofReader/Layout'
import { useRedirectToWritingAssistantIdPage } from '@chegg-wt/core/hooks/paraphraser/useRedirectToPaperId'
import { useDispatch, useSelector } from 'react-redux'
import SEOTitle from '@chegg-wt/core/components/SEOTitle'
import MetaDescription from '@chegg-wt/core/components/Head/MetaDescription'
import { isRioInitSelector } from '@chegg-wt/core/state/instrumentation/selectors'
import { locationChange } from '@chegg-wt/core/state/app/actions'
import { AppRouteName } from '@chegg-wt/core/types/core'
import {
  WRITING_ASSISTSANT_SEO_DESCRIPTION,
  WRITING_ASSISTSANT_SEO_TITLE,
} from '../../utils/seo'

const ProofReaderPage: NextPageWithLayout = () => {
  const dispatch = useDispatch()
  const isRioInit = useSelector(isRioInitSelector)

  useEffect(() => {
    if (isRioInit) {
      //! we can send updated view only when rio has initialise, else it always uses initial state view
      dispatch(
        locationChange({
          routeName: 'toWritingAssistant' as AppRouteName,
          pageName: 'draft page',
        })
      )
    }
  }, [isRioInit])
  useRedirectToWritingAssistantIdPage()

  return (
    <>
      <SEOTitle title={WRITING_ASSISTSANT_SEO_TITLE} />
      <MetaDescription content={WRITING_ASSISTSANT_SEO_DESCRIPTION} />
      <ProofReaderLayout />
    </>
  )
}

ProofReaderPage.getPageLayout = () => <ProofReaderPage />

export default ProofReaderPage
